import { Injectable } from "@angular/core";
import { NotificationPublisherService as ApplicationNotificationPublisherService } from "./application/notification-publisher.service";
import { NotificationPublisherService as CoreNotificationPublisherService } from "./core/notification-publisher.service";
import { NotificationPublisherService as Pillar3aNotificationPublisherService } from "./quote/pillar-3a/notification-publisher.service";
import { NotificationPublisherService as TermLifeInsuranceNotificationPublisherService } from "./quote/term-life-insurance/notification-publisher.service";

/**
 * This service calls out to the notification publisher service of each feature state slice for which we would like to trigger notifications.
 * The ReplaySubject in those notification publisher services allows us to not only provide the current feature state but also the previous one.
 * On top of that we also provide the current notification messages.
 * Both of those arguments allow us to have more granular filtering when exactly a certain notification should be displayed.
 *
 * The business logic when a given notification logic should be displayed was extracted to the corresponding
 * notification service.
 *
 * The notification publisher services should not contain any business logic and only provide the required information
 * for the notification service.
 *
 * Note: The objects passed into our notification services are being frozen by NGRX (Object.isFrozen) and thus can not be used to modify the store by accident.
 */
@Injectable({
  providedIn: "root",
})
export class BackgroundSubscriptionNotificationPublisherService {
  constructor(
    private readonly _coreNotificationPublisherService: CoreNotificationPublisherService,
    private readonly _termLifeInsuranceNotificationPublisherService: TermLifeInsuranceNotificationPublisherService,
    private readonly _pillar3aNotificationPublisherService: Pillar3aNotificationPublisherService,
    private readonly _applicationNotificationPublisherService: ApplicationNotificationPublisherService,
  ) {}

  start() {
    // Core
    this._coreNotificationPublisherService.start();

    // Quote
    this._termLifeInsuranceNotificationPublisherService.start();
    this._pillar3aNotificationPublisherService.start();

    // Application
    this._applicationNotificationPublisherService.start();
  }
}
